import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import { Slider } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'

function CaptureYourDay({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const handleChange = (e, min, max, type) => {
		const value = Number(e.target.value)
		if (value >= min && value <= max) {
			setWeddingData({
				...weddingData,
				captureCount: {
					...weddingData.captureCount,
					[type]: value,
				},
			})
		}
	}
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack(2)}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>How do you want to capture your day?</h2>

					<p style={{ marginTop: '15px' }}>Photographers</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '5px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.priceRange}>
								<input
									value={weddingData.captureCount.photography}
									onChange={(e) =>
										handleChange(e, 0, 5, 'photography')
									}
									style={{
										width: 'fit-content',
										margin: '0 auto',
										textAlign: 'center',
										fontFamily: 'var(--body-font-one)',
										fontWeight: '400',
									}}
								/>
							</div>
						</div>
						<div style={{ padding: '0 30px' }}>
							<Slider
								value={weddingData.captureCount.photography}
								onChange={(e) =>
									handleChange(e, 0, 5, 'photography')
								}
								min={0}
								max={5}
								sx={{
									color: '#7ca6bd',
									width: '100%',
									marginTop: '-15px',
									'& .MuiSlider-track': {
										backgroundColor: '#7ca6bd',
									},
									'& .MuiSlider-thumb': {
										border: '0.1px solid white',
										width: '12px',
										height: '12px',
									},
									'& .MuiSlider-rail': {
										backgroundColor: '#FFFFFF',
										opacity: 1,
									},
								}}
							/>
						</div>
					</div>

					<p style={{ marginTop: '5px' }}>Videographers</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '5px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.priceRange}>
								<input
									value={weddingData.captureCount.videography}
									onChange={(e) =>
										handleChange(e, 0, 5, 'videography')
									}
									style={{
										width: 'fit-content',
										margin: '0 auto',
										textAlign: 'center',
										fontFamily: 'var(--body-font-one)',
										fontWeight: '400',
									}}
								/>
							</div>
						</div>
						<div style={{ padding: '0 30px' }}>
							<Slider
								value={weddingData.captureCount.videography}
								onChange={(e) =>
									handleChange(e, 0, 5, 'videography')
								}
								min={0}
								max={5}
								sx={{
									color: '#7ca6bd',
									width: '100%',
									marginTop: '-15px',
									'& .MuiSlider-track': {
										backgroundColor: '#7ca6bd',
									},
									'& .MuiSlider-thumb': {
										border: '0.1px solid white',
										width: '12px',
										height: '12px',
									},
									'& .MuiSlider-rail': {
										backgroundColor: '#FFFFFF',
										opacity: 1,
									},
								}}
							/>
						</div>
					</div>

					<p style={{ marginTop: '5px' }}>Content creators</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '5px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.priceRange}>
								<input
									value={
										weddingData.captureCount.contentCreation
									}
									onChange={(e) =>
										handleChange(e, 0, 2, 'contentCreation')
									}
									style={{
										width: 'fit-content',
										margin: '0 auto',
										textAlign: 'center',
										fontFamily: 'var(--body-font-one)',
										fontWeight: '400',
									}}
								/>
							</div>
						</div>
						<div style={{ padding: '0 30px' }}>
							<Slider
								value={weddingData.captureCount.contentCreation}
								onChange={(e) =>
									handleChange(e, 0, 2, 'contentCreation')
								}
								min={0}
								max={2}
								sx={{
									color: '#7ca6bd',
									width: '100%',
									marginTop: '-15px',
									'& .MuiSlider-track': {
										backgroundColor: '#7ca6bd',
									},
									'& .MuiSlider-thumb': {
										border: '0.1px solid white',
										width: '12px',
										height: '12px',
									},
									'& .MuiSlider-rail': {
										backgroundColor: '#FFFFFF',
										opacity: 1,
									},
								}}
							/>
						</div>
					</div>

					<p style={{ marginTop: '5px' }}>Photobooths</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '5px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.priceRange}>
								<input
									value={weddingData.captureCount.photobooth}
									onChange={(e) =>
										handleChange(e, 0, 2, 'photobooth')
									}
									style={{
										width: 'fit-content',
										margin: '0 auto',
										textAlign: 'center',
										fontFamily: 'var(--body-font-one)',
										fontWeight: '400',
									}}
								/>
							</div>
						</div>
						<div style={{ padding: '0 30px' }}>
							<Slider
								value={weddingData.captureCount.photobooth}
								onChange={(e) =>
									handleChange(e, 0, 2, 'photobooth')
								}
								min={0}
								max={2}
								sx={{
									color: '#7ca6bd',
									width: '100%',
									marginTop: '-15px',
									'& .MuiSlider-track': {
										backgroundColor: '#7ca6bd',
									},
									'& .MuiSlider-thumb': {
										border: '0.1px solid white',
										width: '12px',
										height: '12px',
									},
									'& .MuiSlider-rail': {
										backgroundColor: '#FFFFFF',
										opacity: 1,
									},
								}}
							/>
						</div>
					</div>
				</div>
				<ButtonCustom size="lg" data-cy="wizard-next" onClick={() => handleNext()}>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.8} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default CaptureYourDay
